import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kitchen_linens: FaireCategoryEntity = {
  token: "cat_kitchen-linens",
  type: "category",
  name: "Kitchen & tabletop linens",
  level: 3,
  parentToken: "cat_home-decor-kitchen-tabletop",
  href: "/category/home-decor/kitchen-tabletop/linens",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
